import { message } from "antd";
import axios from "axios";

const URL = process.env.REACT_APP_BASE_URL_DEV;
const apiBaseURL = `${URL}/api`;
const instance = axios.create({ baseURL: apiBaseURL, withCredentials: true });
const getAxiosInstance = () => instance;

let isNetworkAlertShown = false;
window.addEventListener("online", () => {
    isNetworkAlertShown = false;
});

const handleLogout = () => {
    ["cx_expiration", "cx_lastActivityTime"].forEach(
        (key) => localStorage.removeItem(key)
    );
    message.error("Something went wrong. Please login again")
    document.body.innerHTML = "";
    window.location.replace("/");
    // window.location.reload();
};
let isRefreshing = false;
let failedQueue = [];
const processQueue = (error) => {
    failedQueue.forEach(prom => {
        if (error) prom.reject(error);
        else prom.resolve();
    });
    failedQueue = [];
};

let licenceLogoutHandler = null;
const registerLicenceLogoutHandler = (fn) => {
    licenceLogoutHandler = fn;
};

const forceLogout = async () => {
    const licenceLogoutCall = Promise.resolve()
        .then(() => licenceLogoutHandler?.())
        .catch(() => { });

    const expiredLogoutCall = axios
        .post(`${apiBaseURL}/usermgmt/logoutExpired`, {}, { withCredentials: true })
        .catch(() => { });

    await Promise.all([expiredLogoutCall, licenceLogoutCall]);
    handleLogout();
};
instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (
            error.code === "ERR_NETWORK" ||
            error.message === "Network Error"
        ) {
            if (!isNetworkAlertShown) {
                isNetworkAlertShown = true;
                alert("No internet connection. Please try again.");
                message.error({
                    content: "No internet connection. Please try again.",
                    duration: 5,
                });
            }
            // return Promise.reject(error);
        }
        const originalRequest = error.config;
        if (
            error.response?.status === 401 &&
            !originalRequest.retryRequest
        ) {
            if (originalRequest.url?.includes("/usermgmt/refresh")) {
                processQueue(error);
                await forceLogout();
                return Promise.reject(error);
            }
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => instance(originalRequest));
            }
            originalRequest.retryRequest = true;
            isRefreshing = true;
            try {
                await instance.post("/usermgmt/refresh");
                processQueue(null);
                return instance(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError);
                await forceLogout();
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);

const AssetURL = process.env.REACT_APP_ASSET_BASE_URL;
const BaseURL = `${AssetURL}/api`;
const assetInstance = axios.create({ baseURL: BaseURL });
const AxiosAssetInstance = () => assetInstance;

assetInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (
            error.code === "ERR_NETWORK" ||
            error.message === "Network Error"
        ) {
            if (!isNetworkAlertShown) {
                isNetworkAlertShown = true;
                alert("No internet connection. Please try again.");
                message.error({
                    content: "No internet connection. Please try again.",
                    duration: 5,
                });
            }
        }
        return Promise.reject(error);
    }
);

const LPURL = process.env.REACT_APP_LANDING_BASE_URL;
const BasEURL = `${LPURL}/api`;
const lpInstance = axios.create({ baseURL: BasEURL });
const AxiosLPInstance = () => lpInstance;

lpInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (
            error.code === "ERR_NETWORK" ||
            error.message === "Network Error"
        ) {
            if (!isNetworkAlertShown) {
                isNetworkAlertShown = true;
                alert("No internet connection. Please try again.");
                message.error({
                    content: "No internet connection. Please try again.",
                    duration: 5,
                });
            }
        }
        return Promise.reject(error);
    }
);

const LMURL = process.env.REACT_APP_BASE_URL_LM;
const BaseLMURL = `${LMURL}/api`;
const lmInstance = axios.create({ baseURL: BaseLMURL });
const AxiosLMInstance = () => lmInstance;

lmInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (
            error.code === "ERR_NETWORK" ||
            error.message === "Network Error"
        ) {
            if (!isNetworkAlertShown) {
                isNetworkAlertShown = true;
                alert("No internet connection. Please try again.");
                message.error({
                    content: "No internet connection. Please try again.",
                    duration: 5,
                });
            }
        }
        return Promise.reject(error);
    }
);

export {
    getAxiosInstance,
    AxiosAssetInstance,
    AxiosLPInstance,
    AxiosLMInstance,
    registerLicenceLogoutHandler,
};